import { FooterComponent, HeaderComponent } from './components';

import { CommonModule } from '@angular/common';
import {MatToolbarModule} from '@angular/material/toolbar';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WgThemerModule } from 'wg-themer';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AngularMaterialModule } from '../angular-material/angular-material-module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [FooterComponent, HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    WgThemerModule,
    ScrollingModule,
    AngularMaterialModule,
    MarkdownModule.forChild()
  ],
  exports: [FooterComponent, HeaderComponent]
})
export class CoreModule { }
